import { actionTypes } from '../../constants/actionTypes';
import { initialState } from './store';

interface ReducerAction {
  type: string;
  [index: string]: any;
}

export const reducer = (state = initialState, action: ReducerAction) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SIDEBAR: {
      return {
        ...state,
        sidebarOpen: action.sidebarOpen,
      };
    }
    case actionTypes.SET_TOPTRENDS_LIST: {
      if (JSON.stringify(state.topTrendsList) === JSON.stringify(action.topTrendsList)) {
        return state;
      }

      return {
        ...state,
        topTrendsList: action.topTrendsList,
      };
    }
    case actionTypes.SET_FULL_SCREEN: {
      return {
        ...state,
        showFullScreen: action.showFullScreen,
        sidebarOpen: action.sidebarOpen,
      };
    }
    case actionTypes.SET_EXPLORES_DATA: {
      if (JSON.stringify(state.explores) === JSON.stringify(action.explores)) {
        return state;
      }

      return {
        ...state,
        explores: action.explores,
      };
    }
    case actionTypes.SET_LOOKS_LIST: {
      if (action.reset) {
        return {
          ...state,
          looksList: action.looksList,
        };
      } else {
        // dedupe entries in the list
        const looksMap = new Map();
        state.looksList.forEach((look) => looksMap.set(look.id, look));
        action.looksList?.forEach((look) => looksMap.set(look.id, look));

        const newLooksList = Array.from(looksMap.values()).sort();

        if (JSON.stringify(state.looksList) === JSON.stringify(newLooksList)) {
          return state;
        }

        return {
          ...state,
          looksList: newLooksList,
        };
      }
    }
    case actionTypes.SET_DASHBOARDS_LIST: {
      if (JSON.stringify(state.dashboardsList) === JSON.stringify(action.dashboardsList)) {
        return state;
      }

      return {
        ...state,
        dashboardsList: [...state.dashboardsList, ...action.dashboardsList],
      };
    }
    case actionTypes.SET_BLOB_URL: {
      return {
        ...state,
        blobUrls: { ...state.blobUrls, [action.id]: action.url },
      };
    }
    case actionTypes.SET_LOOKER_PERMISSIONS: {
      if (JSON.stringify(state.looker_permissions) === JSON.stringify(action.looker_permissions)) {
        return state;
      }

      return {
        ...state,
        looker_permissions: action.looker_permissions,
      };
    }
    case actionTypes.SET_SNACKBAR: {
      if (JSON.stringify(state.snackConfig) === JSON.stringify(action.snackConfig)) {
        return state;
      }

      return {
        ...state,
        snackConfig: { ...action.snackConfig },
      };
    }
    case actionTypes.SET_CONFIRMATION_MODAL: {
      if (JSON.stringify(state.confirmationModal) === JSON.stringify(action.modalConfig)) {
        return state;
      }

      return {
        ...state,
        confirmationModal: { ...action.modalConfig },
      };
    }
    case actionTypes.SET_ADHOC_ANALYSIS_FOLDERS: {
      if (JSON.stringify(state.adHocAnalysisFolders) === JSON.stringify(action.adHocAnalysisFolders)) {
        return state;
      }

      return {
        ...state,
        adHocAnalysisFolders: action.adHocAnalysisFolders,
      };
    }
    case actionTypes.SET_SEGMENT_FILTERS_DATA: {
      if (JSON.stringify(state.segmentFiltersData) === JSON.stringify(action.segmentFiltersData)) {
        return state;
      }

      return {
        ...state,
        segmentFiltersData: { ...action.segmentFiltersData },
      };
    }
    case actionTypes.SET_SUMMARY_METRIC_DATA: {
      if (JSON.stringify(state.summaryMetricData) === JSON.stringify(action.summaryMetricData)) {
        return state;
      }

      return {
        ...state,
        summaryMetricData: { ...action.summaryMetricData },
      };
    }
    case actionTypes.SET_DRILLDOWN_METRIC_DATA: {
      if (JSON.stringify(state.drilldownCachedMetricData) === JSON.stringify(action.drilldownCachedMetricData)) {
        return state;
      }

      return {
        ...state,
        drilldownCachedMetricData: { ...action.drilldownCachedMetricData },
      };
    }
    case actionTypes.SET_SLACK_CHANNELS: {
      if (JSON.stringify(state.slackChannels) === JSON.stringify(action.slackChannels)) {
        return state;
      }

      return {
        ...state,
        slackChannels: [...action.slackChannels],
      };
    }
    case actionTypes.ADD_LOADER: {
      if (!action.loaderName) {
        return state;
      }

      return {
        ...state,
        loadersArray: [...state.loadersArray, action.loaderName],
      };
    }
    case actionTypes.REMOVE_LOADER: {
      if (!action.loaderName) {
        return state;
      }

      const currentLoaderArray = [...state.loadersArray];
      currentLoaderArray.splice(currentLoaderArray.indexOf(action.loaderName), 1);
      return {
        ...state,
        loadersArray: [...currentLoaderArray],
      };
    }
    case actionTypes.SET_COMPETITORS_DATA: {
      if (JSON.stringify(state.competitorsData) === JSON.stringify(action.competitorsData)) {
        return state;
      }

      return {
        ...state,
        competitorsData: action.competitorsData,
      };
    }
    case actionTypes.SET_TOP_N_DATA: {
      if (JSON.stringify(state.topNData) === JSON.stringify(action.topNData)) {
        return state;
      }

      return {
        ...state,
        topNData: action.topNData,
      };
    }
    case actionTypes.SET_DRILL_DOWN_ROW_DATA: {
      if (JSON.stringify(state.drillDownRowData) === JSON.stringify(action.drillDownRowData)) {
        return state;
      }

      return {
        ...state,
        drillDownRowData: action.drillDownRowData,
      };
    }
    case actionTypes.UPDATE_GT_SELECTED_FILTERS: {
      return {
        ...state,
        gtSelectedFilters: { ...state.gtSelectedFilters, ...action.gtSelectedFilters },
      };
    }
    case actionTypes.UPDATE_ST_SELECTED_FILTERS: {
      return {
        ...state,
        stSelectedFilters: { ...state.stSelectedFilters, ...action.stSelectedFilters },
      };
    }
    case actionTypes.SET_HEADER_INFO: {
      if (JSON.stringify(state.headerInfo) === JSON.stringify(action.payload)) {
        return state;
      }

      return {
        ...state,
        headerInfo: {
          ...action.payload,
        },
      };
    }
    case actionTypes.UNSET_HEADER_INFO: {
      return {
        ...state,
        headerInfo: {
          title: '',
        },
      };
    }
    case actionTypes.SET_POTENTIAL_OPPORTUNITY_LIST: {
      if (JSON.stringify(state.potentialOpportunityList) === JSON.stringify(action.potentialOpportunityList)) {
        return state;
      }

      return {
        ...state,
        potentialOpportunityList: action.potentialOpportunityList,
      };
    }
    case actionTypes.SET_TOP_OPPORTUNITY_LIST: {
      if (JSON.stringify(state.topOpportunityList) === JSON.stringify(action.topOpportunityList)) {
        return state;
      }

      return {
        ...state,
        topOpportunityList: action.topOpportunityList,
      };
    }
    case actionTypes.SET_GROWTH_TREND_MARKET_SHARE_FILTERS: {
      if (JSON.stringify(state.growthTrendsMarketShareFilters) === JSON.stringify(action.filtersData)) {
        return state;
      }

      return {
        ...state,
        growthTrendsMarketShareFilters: {
          ...action.filtersData,
        },
      };
    }
    case actionTypes.SET_USABILITY_RECOMMENDATION_LIST: {
      if (JSON.stringify(state.usabilityRecommendationList) === JSON.stringify(action.usabilityRecommendationList)) {
        return state;
      }

      return {
        ...state,
        usabilityRecommendationList: action.usabilityRecommendationList,
      };
    }
    case actionTypes.SET_CONTENT_RECOMMENDATION_DATA: {
      if (JSON.stringify(state.contentRecommendationList) === JSON.stringify(action.contentRecommendationList)) {
        return state;
      }

      return {
        ...state,
        contentRecommendationList: action.contentRecommendationList,
      };
    }
    case actionTypes.SET_CONTENT_BRIEF_DATA: {
      if (JSON.stringify(state.contentBriefList) === JSON.stringify(action.contentBriefList)) {
        return state;
      }

      return {
        ...state,
        contentBriefList: action.contentBriefList,
      };
    }
    case actionTypes.SET_PAGES_UPLOADS: {
      if (JSON.stringify(state.customerPagesUploads) === JSON.stringify(action.customerPagesUploads)) {
        return state;
      }

      return {
        ...state,
        customerPagesUploads: action.customerPagesUploads,
      };
    }
    case actionTypes.SET_KEYWORDS_UPLOADS: {
      if (JSON.stringify(state.customerKeywordsUploads) === JSON.stringify(action.customerKeywordsUploads)) {
        return state;
      }

      return {
        ...state,
        customerKeywordsUploads: action.customerKeywordsUploads,
      };
    }
    case actionTypes.SET_PRIMARY_SEGMENT_NAME: {
      if (JSON.stringify(state.segment1_name) === JSON.stringify(action.segment1_name)) {
        return state;
      }

      return {
        ...state,
        segment1_name: action.segment1_name,
      };
    }
    case actionTypes.SET_SECONDARY_SEGMENT_NAME: {
      if (JSON.stringify(state.segment2_name) === JSON.stringify(action.segment2_name)) {
        return state;
      }

      return {
        ...state,
        segment2_name: action.segment2_name,
      };
    }
    case actionTypes.SET_CUSTOMER_INFO: {
      // to prevent rerender when customer info is updated from other components
      if (JSON.stringify(state.customerInfo) === JSON.stringify(action.customerInfo)) {
        return state;
      }
      return {
        ...state,
        customerInfo: action.customerInfo,
      };
    }
    case actionTypes.SET_GLOBAL_DATE_RANGE_FILTERS: {
      if (JSON.stringify(state.datePickerFilter) === JSON.stringify(action.filtersData)) {
        return state;
      }

      return {
        ...state,
        datePickerFilter: action.filtersData,
      };
    }
    case actionTypes.SET_USER_SELECTED_DATE_RANGE: {
      return {
        ...state,
        userSelectedDateRange: action.userSelectedDateRange,
      };
    }
    case actionTypes.SET_DEFAULT_DATE_RANGE: {
      if (JSON.stringify(state.defaultDateRange) === JSON.stringify(action.defaultDateRange)) {
        return state;
      }

      return {
        ...state,
        defaultDateRange: action.defaultDateRange,
      };
    }
    case actionTypes.SET_RECOMMENDATION_FILTERS_DATA: {
      if (JSON.stringify(state.recommendationFiltersData) === JSON.stringify(action.filtersData)) {
        return state;
      }

      return {
        ...state,
        recommendationFiltersData: action.filtersData,
      };
    }
    case actionTypes.SET_CONTENT_RECOMMENDATION_FILTERS_DATA: {
      return {
        ...state,
        contentRecommendationFiltersData: { ...state.contentRecommendationFiltersData, ...action.filtersData },
      };
    }
    case actionTypes.SET_USABILITY_METRICS_SCORE: {
      if (JSON.stringify(state.usabilityScore) === JSON.stringify(action.usabilityScore)) {
        return state;
      }

      return {
        ...state,
        usabilityScore: action.usabilityScore,
      };
    }
    case actionTypes.SET_DOMAIN: {
      if (state.defaultDomain === action.defaultDomain) {
        return state;
      }

      if (action.defaultDomain === '/') {
        return state;
      }

      return {
        ...state,
        defaultDomain: action.defaultDomain,
      };
    }
    case actionTypes.SET_MARKET_SEGMENT: {
      if (JSON.stringify(state.defaultMarketSegment) === JSON.stringify(action.defaultMarketSegment)) {
        return state;
      }

      return {
        ...state,
        defaultMarketSegment: action.defaultMarketSegment,
      };
    }
    case actionTypes.SET_CR_DETAILS_MODAL: {
      if (JSON.stringify(state.crDetailsModal) === JSON.stringify(action.crDetailsModal)) {
        return state;
      }

      return {
        ...state,
        crDetailsModal: action.crDetailsModal,
      };
    }
    case actionTypes.ADD_PAGE_TO_OPTIMIZE_FORM_BOX: {
      if (
        JSON.stringify(state?.addPageToOptimizeModelForTrends) ===
        JSON.stringify(action.addPageToOptimizeModelForTrends)
      ) {
        return state;
      }
      return {
        ...state,
        addPageToOptimizeModelForTrends: action.addPageToOptimizeModelForTrends,
      };
    }
    case actionTypes.SET_LOOKER_USER_ID: {
      if (JSON.stringify(state.lookerUserId) === JSON.stringify(action.lookerUserId)) {
        return state;
      }

      return {
        ...state,
        lookerUserId: action.lookerUserId,
      };
    }
    case actionTypes.SET_INTENT_LIST: {
      if (JSON.stringify(state.intentList) === JSON.stringify(action.intentList)) {
        return state;
      }

      return {
        ...state,
        intentList: action.intentList,
      };
    }
    case actionTypes.SET_RULES_LIST: {
      if (JSON.stringify(state.ruleList) === JSON.stringify(action.ruleList)) {
        return state;
      }

      return {
        ...state,
        ruleList: action.ruleList,
      };
    }
    case actionTypes.SET_ENTITY_LIST: {
      if (JSON.stringify(state.entityList) === JSON.stringify(action.entityList)) {
        return state;
      }

      return {
        ...state,
        entityList: action.entityList,
      };
    }
    case actionTypes.STORE_RULES_LIST: {
      if (JSON.stringify(state.ruleStoreList) === JSON.stringify(action.ruleStoreList)) {
        return state;
      }

      return {
        ...state,
        ruleStoreList: action.ruleStoreList,
      };
    }
    case actionTypes.SET_ALL_SEARCH_INTENT_LIST: {
      if (JSON.stringify(state.intentAllSearchList) === JSON.stringify(action.intentAllSearchList)) {
        return state;
      }

      return {
        ...state,
        intentAllSearchList: action.intentAllSearchList,
      };
    }
    case actionTypes.SET_ELEMENT_MAPPING_DETAILS: {
      if (JSON.stringify(state.elementMappingDetails) === JSON.stringify(action.elementMappingDetails)) {
        return state;
      }

      return {
        ...state,
        elementMappingDetails: action.elementMappingDetails,
      };
    }
    case actionTypes.SET_ELEMENT_MAPPING_DETAILS_COMPETITOR: {
      return {
        ...state,
        elementMappingDetailsCompetitor: action.elementMappingDetails,
      };
    }
    case actionTypes.UPDATE_CONTENT_QUALITY_SCORE: {
      const newState = { ...state };
      if (newState.contentRecommendationList.length > 0) {
        const updatedList = newState.contentRecommendationList.map((item) => {
          if (action.payload.url === item.finalurl) {
            item.projectedContentQualityScore = action.payload.newProjectedScore;
          }
          return item;
        });
        newState.contentRecommendationList = [...updatedList];
      }
      return newState;
    }
    // case actionTypes.SET_CUSTOMER_PREVIEW_HTML:
    //   return {
    //     ...state,
    //     customerPreviewHtml: action.htmlContent,
    //   };
    case actionTypes.SET_INTENT_SUMMARY: {
      if (JSON.stringify(state.intentSummaryData) === JSON.stringify(action.intentSummaryData)) {
        return state;
      }

      return {
        ...state,
        intentSummaryData: action.intentSummaryData,
      };
    }
    case actionTypes.SET_ALL_SEARCH_INTENT_SUMMARY: {
      if (JSON.stringify(state.intentAllSearchSummaryData) === JSON.stringify(action.intentAllSearchSummaryData)) {
        return state;
      }

      return {
        ...state,
        intentAllSearchSummaryData: action.intentAllSearchSummaryData,
      };
    }
    case actionTypes.SET_CATEGORY_LIST: {
      if (JSON.stringify(state.categoryList) === JSON.stringify(action.categoryList)) {
        return state;
      }

      return {
        ...state,
        categoryList: action.categoryList,
      };
    }

    case actionTypes.SET_CATEGORY_PAGE_LIST: {
      if (JSON.stringify(state.categoryPageList) === JSON.stringify(action.categoryPageList)) {
        return state;
      }

      return {
        ...state,
        categoryPageList: action.categoryPageList,
      };
    }

    case actionTypes.SET_CATEGORY_SUMMARY: {
      if (JSON.stringify(state.categorySummaryData) === JSON.stringify(action.categorySummaryData)) {
        return state;
      }

      return {
        ...state,
        categorySummaryData: action.categorySummaryData,
      };
    }
    case actionTypes.SET_ALL_SEARCH_CATEGORY_LIST: {
      if (JSON.stringify(state.categoryAllSearchList) === JSON.stringify(action.categoryAllSearchList)) {
        return state;
      }

      return {
        ...state,
        categoryAllSearchList: action.categoryAllSearchList,
      };
    }
    case actionTypes.SET_ALL_SEARCH_CATEGORY_SUMMARY: {
      if (JSON.stringify(state.categoryAllSearchSummaryData) === JSON.stringify(action.categoryAllSearchSummaryData)) {
        return state;
      }

      return {
        ...state,
        categoryAllSearchSummaryData: action.categoryAllSearchSummaryData,
      };
    }

    case actionTypes.CR_FULL_SCREEN_SPINNER: {
      if (JSON.stringify(state.showCrFullScreenSpinner) === JSON.stringify(action.showCrFullScreenSpinner)) {
        return state;
      }

      return {
        ...state,
        showCrFullScreenSpinner: action.showCrFullScreenSpinner,
      };
    }
    case actionTypes.CR_PAGE_TAGS_HTML_DATA_COLLECTION: {
      if (JSON.stringify(state.crPageTagsHtmlDataCollection) === JSON.stringify(action.crPageTagsHtmlDataCollection)) {
        return state;
      }

      return {
        ...state,
        crPageTagsHtmlDataCollection: action.crPageTagsHtmlDataCollection,
      };
    }
    case actionTypes.ALL_COMPETITORS_HTML_DATA: {
      if (JSON.stringify(state.allCompetitorsHtmlData) === JSON.stringify(action.allCompetitorsHtmlData)) {
        return state;
      }

      return {
        ...state,
        allCompetitorsHtmlData: action.allCompetitorsHtmlData,
      };
    }

    case actionTypes.PAGE_ALL_HTML_DATA: {
      if (JSON.stringify(state.pageAllHtmlData) === JSON.stringify(action.pageAllHtmlData)) {
        return state;
      }

      return {
        ...state,
        pageAllHtmlData: action.pageAllHtmlData,
      };
    }
    case actionTypes.TOPICS_DATA: {
      if (JSON.stringify(state.topicsData) === JSON.stringify(action.topicsData)) {
        return state;
      }

      return {
        ...state,
        topicsData: action.topicsData,
      };
    }

    case actionTypes.KEYWORDS_DATA: {
      if (JSON.stringify(state.keywordsData) === JSON.stringify(action.keywordsData)) {
        return state;
      }
      const cikKeywordsData = [...action.keywordsData]?.filter((ckd) => ckd?.is_cluster_included);
      const combinedKeywordsData = combineKeywordsData(
        cikKeywordsData,
        state.potentialKeywordsData,
        state.aiKeywordsData
      );
      return {
        ...state,
        cikKeywordsData: cikKeywordsData,
        keywordsData: combinedKeywordsData,
      };
    }

    case actionTypes.POTENTIAL_KEYWORDS_DATA: {
      if (JSON.stringify(state.potentialKeywordsData) === JSON.stringify(action.potentialKeywordsData)) {
        return state;
      }
      const combinedKeywordsData = combineKeywordsData(
        state.cikKeywordsData,
        action.potentialKeywordsData,
        state.aiKeywordsData
      );

      return {
        ...state,
        potentialKeywordsData: action.potentialKeywordsData,
        keywordsData: combinedKeywordsData,
      };
    }
    case actionTypes.AI_KEYWORDS_DATA: {
      if (JSON.stringify(state.aiKeywordsData) === JSON.stringify(action.aiKeywordsData)) {
        return state;
      }
      const combinedKeywordsData = combineKeywordsData(
        state.cikKeywordsData,
        state.potentialKeywordsData,
        action.aiKeywordsData
      );

      return {
        ...state,
        aiKeywordsData: action.aiKeywordsData,
        keywordsData: combinedKeywordsData,
      };
    }

    case actionTypes.RE_UPDATE_ALL_KEYWORDS_DATA: {
      const combinedKeywordsData = combineKeywordsData(
        state.cikKeywordsData,
        action.potentialKeywordsData,
        action.aiKeywordsData
      );
      return {
        ...state,
        potentialKeywordsData: action.potentialKeywordsData,
        aiKeywordsData: action.aiKeywordsData,
        keywordsData: combinedKeywordsData,
      };
    }

    case actionTypes.IS_INCLUDED_KEYWORDS_PIPELINE_TRIGGER: {
      if (
        JSON.stringify(state.isTriggerIncludedPotentialKeyword) ===
        JSON.stringify(action.isTriggerIncludedPotentialKeyword)
      ) {
        return state;
      }

      return {
        ...state,
        isTriggerIncludedPotentialKeyword: action.isTriggerIncludedPotentialKeyword,
      };
    }
    case actionTypes.NEW_KEYWORD_TO_POTENTIAL_KEYWORDS_DATA: {
      const newPotentialKeywordData = [...state.potentialKeywordsData];
      newPotentialKeywordData.push(...action.payload);
      return {
        ...state,
        potentialKeywordsData: newPotentialKeywordData,
      };
    }
    case actionTypes.MASTER_COUNTRY_AND_LANGUAGE: {
      if (JSON.stringify(state.masterLanguageAndCountry) === JSON.stringify(action.payload)) {
        return state;
      }

      return {
        ...state,
        masterLanguageAndCountry: action.payload,
      };
    }
    case actionTypes.SET_NEW_PAGE_CONTENT_RECOMMENDATION_DATA: {
      const crList = [...state.contentRecommendationList];
      crList.unshift(action.payload);
      return {
        ...state,
        contentRecommendationList: crList,
      };
    }

    case actionTypes.ADD_NEW_PAGE_IN_CR_FILTERS: {
      const contentRecommendationFiltersData = { ...state.contentRecommendationFiltersData };
      if (contentRecommendationFiltersData && contentRecommendationFiltersData.page) {
        contentRecommendationFiltersData.page.unshift({ top_data: action.page });
      } else {
        contentRecommendationFiltersData.page = [{ top_data: action.page }];
      }
      return {
        ...state,
        contentRecommendationFiltersData: contentRecommendationFiltersData,
      };
    }

    case actionTypes.GLOBAL_AUTO_WRITER_MAGIC_PIN: {
      const currentData = { ...state.globalAutoWriterMagicPin };
      return {
        ...state,
        globalAutoWriterMagicPin: {
          ...currentData,
          open: !!action?.payload?.open,
          defaultText: action?.payload?.defaultText || '',
        },
      };
    }

    case actionTypes.SET_CONTENT_BRIEF_TINYMCE_STRING: {
      if (JSON.stringify(state.contentBriefTinyMceData) === JSON.stringify(action?.payload)) {
        return state;
      }

      return {
        ...state,
        // contentBriefSting: action?.contents,
        contentBriefTinyMceData: {
          ...state?.contentBriefTinyMceData,
          initialLoad: action?.payload?.initialLoad,
          contentBriefString: action?.payload?.contentBriefString,
        },
      };
    }

    case actionTypes.SET_GPT_STREAMING_DATA: {
      if (!action?.gptStreamingData) {
        return state;
      }

      const oldData = { ...state.gptStreamingData };
      return {
        ...state,
        gptStreamingData: {
          ...oldData,
          ...action?.gptStreamingData,
        },
      };
    }

    case actionTypes.SET_GPT_COMPLETE_CONTENT: {
      return {
        ...state,
        gptCompleteContent: {
          content: action?.content || '',
          timestamp: action?.timestamp || Date.now(),
        },
      };
    }

    case actionTypes.SET_GPT_THINKING_STATE: {
      return {
        ...state,
        gptThinkingState: {
          isThinking: action?.thinking?.isThinking || false,
          status: action?.thinking?.status || '',
          message: action?.thinking?.message || '',
        },
      };
    }

    case actionTypes.SET_GPT_THINKING_CONTENT: {
      const currentContent = state.gptThinkingContent || '';
      const shouldAppend = action?.append !== false; // Default to true if not specified
      return {
        ...state,
        gptThinkingContent: shouldAppend
          ? currentContent + (action?.thinkingContent || '')
          : action?.thinkingContent || '',
      };
    }

    case actionTypes.SET_GPT_PERSISTED_THINKING_CONTENT: {
      return {
        ...state,
        gptPersistedThinkingContent: {
          content: action?.content || '',
          timestamp: action?.timestamp || Date.now(),
          promptInfo: {
            promptFor: action?.promptInfo?.promptFor || '',
            keyword: action?.promptInfo?.keyword || '',
            title: action?.promptInfo?.title || '',
          },
        },
      };
    }

    case actionTypes.SET_WEB_SOCKET_INSTANCE: {
      return {
        ...state,
        wsInstance: action?.wsInstance,
      };
    }

    case actionTypes.SET_SHOW_SUBSCRIPTION_BANNER: {
      return {
        ...state,
        showSubscriberBanner: action?.showSubscriberBanner,
      };
    }

    case actionTypes.SET_CUSTOM_POPUP_STATUS: {
      return {
        ...state,
        customPopupConfig: {
          showPopup: action?.customPopupConfig?.showPopup,
          text: action?.customPopupConfig?.text,
          anchorText: action?.customPopupConfig?.anchorText,
          anchorLink: action?.customPopupConfig?.anchorLink,
        },
      };
    }

    case actionTypes.SET_SUBSCRIBER_META: {
      return {
        ...state,
        subscriberMeta: action?.subscriberMeta,
      };
    }

    case actionTypes.SET_CREDITS_REMAINING: {
      return {
        ...state,
        creditsRemaining: action?.creditsRemaining,
      };
    }

    case actionTypes.SET_REMAINING_DAY_PASS_CREDITS: {
      return {
        ...state,
        dayPassCreditsRemaining: action?.dayPassCreditsRemaining,
      };
    }

    case actionTypes.SET_CREDITS_REQUIRED_PER_DAY: {
      return {
        ...state,
        creditsUsagePerDay: action?.creditsUsagePerDay,
      };
    }

    case actionTypes.SET_INTERNAL_LINKING_FILTERS: {
      return {
        ...state,
        internalLinkingFilters: action?.internalLinkingFilters,
      };
    }

    case actionTypes.SET_AUTONOMOUS_INTERNAL_LINKING_DETAILS: {
      return {
        ...state,
        autoNomousInternalLinkingDetails: action?.details,
      };
    }

    case actionTypes.SET_USERS_LIST: {
      if (JSON.stringify(state.usersList) === JSON.stringify(action.usersList)) {
        return state;
      }
      return {
        ...state,
        usersList: action.usersList,
      };
    }

    default:
      return state;
  }
};

const combineKeywordsData = (cikData: any[] = [], cpkData: any[] = [], aiData: any[] = []) => {
  interface typeCluster {
    cluster_id: string;
    keyword: string;
    sub_keyword: string;
    is_included: boolean;
    is_cluster_included: boolean;
  }

  const cpkProcessedButExcludedIds: string[] = [...cpkData]
    ?.filter((c: typeCluster) => c?.cluster_id && !c?.sub_keyword && !c?.is_included && c?.is_cluster_included)
    ?.map((c) => c.cluster_id) as []; //clusterId = processed but currently not  included

  const updatedCIKData = cikData?.filter((cikD) => !cpkProcessedButExcludedIds?.includes(cikD?.cluster_id)); // updatedCikData = all cik excluding  cpk is_included false

  ////aiCLusterIDs = not included or included false
  const aiClusterIDs: string[] = aiData
    ?.filter((c: typeCluster) => c?.cluster_id && !c?.sub_keyword && !c?.is_included)
    ?.map((c) => c?.cluster_id) as [];

  const updatedData: any[] = [...updatedCIKData]?.map((cik) => {
    const newData = { ...cik };
    if (aiClusterIDs.includes(cik?.cluster_id)) {
      newData.is_included = false;
    }
    return newData;
  });

  const cikClusterIDs: string[] = updatedData
    ?.filter(
      (c: typeCluster) => c?.cluster_id && !c?.sub_keyword && !cpkProcessedButExcludedIds?.includes(c?.cluster_id)
    )
    ?.map((c) => c.cluster_id) as [];

  cpkData.forEach((cpk: typeCluster) => {
    if (
      !cikClusterIDs.includes(cpk?.cluster_id) &&
      cpk?.is_included &&
      !cpkProcessedButExcludedIds?.includes(cpk?.cluster_id)
    ) {
      updatedData.push(cpk);
    }
  });

  aiData.forEach((ai: typeCluster) => {
    if (!cikClusterIDs.includes(ai?.cluster_id) && !cpkProcessedButExcludedIds?.includes(ai?.cluster_id)) {
      updatedData.push(ai);
    }
  });

  const cpkClusterIDs: string[] = [...cpkData]
    ?.filter((c: typeCluster) => c?.cluster_id && !c?.sub_keyword)
    ?.map((c) => c.cluster_id) as [];

  const finalData = updatedData?.map((ud) => {
    const newD = { ...ud };
    if (!ud?.sub_keyword && cpkClusterIDs.includes(ud?.cluster_id)) {
      newD.cluster_source = 'dfs';
      newD.is_cpk_data = true;
    }
    return newD;
  });

  return finalData;
};
